import React from 'react';
import SIcon from './SIcon';
import { faSignalGood } from '@fortawesome/pro-duotone-svg-icons';

const Icon = props => <SIcon {...props} icon={faSignalGood} fa />;

export default Icon;
